export class Customer {
    id: string;
    name: string;
    status: string;
    max_debit: string;
    city_id: string;
    address: string;
    manager_name: string;
    mobile: string;
    telephone: string;
    account_no: string;
    fax: string;
    email: string;
    row_id: string;
    tax_number: string;
    creation_user: string;
    type_country: string;
    creation_ip: string;
    created_at: string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/customers/customer.ts